import heroImage1 from '../assets/PL_WEB.jpg';

const HeroImage = () => {
  return (
    <div className="w-full relative overflow-hidden">
      <div className="w-full max-w-[1400px] mx-auto aspect-[16/9] sm:aspect-[21/9] md:aspect-[16/6] lg:aspect-[16/5]">
        <img
          src={heroImage1}
          alt="PL WEB"
          className="w-full h-full object-cover rounded-lg"
        />
      </div>
    </div>
  );
};

export default HeroImage;
